import React, { useEffect, useState } from "react";
import axios from "axios";
import { scoreSport2 } from "../../service/AuthService";

const LiveScoreCardPHP = ({ eventId }) => {

    const [scoreData, setScoreData] = useState(null);
  
    const fetchScore = async () => {
        if (!eventId) return;

        try {
            const { response } = await scoreSport2(eventId);
            if (response?.data?.ScoreData?.Score?.[0]) {
                setScoreData(response?.data?.ScoreData?.Score?.[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };



    useEffect(() => {
        if (!eventId) return;
        fetchScore();
        const interval = setInterval(fetchScore, 800);
        return () => clearInterval(interval);
    }, [eventId]); // ✅ FIXED

    if (!scoreData) return <>
        {/* <tr>
            <td
                colSpan={3}
                height={35}
                align="center"
                className="TeamCombo">
                <p
                    className="price-btn"
                    style={{
                        color: "#00F",
                        fontFamily: "Verdana, Geneva, sans-serif",
                        fontSize: 12,
                        fontWeight: "bold"
                    }}
                >
                    <span
                        style={{ textDecoration: "blink !important" }}
                    >

                    </span>
                    &nbsp;{" "}
                </p>
            </td>
        </tr>
        <tr>
            <td align="left" valign="top" style={{ padding: '0px' }}>
                <table width="100%" border={0} cellSpacing={0} cellPadding={0}>
                    <tbody>

                        <tr>
                            <td
                                width="45%"
                                height={35}
                                align="center"
                                className="TeamCombo"
                                style={{
                                    height: 35,
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                    padding: 5,
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    className="ScoreCard"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "2px dotted #333",
                                        justifyContent: "center",
                                        height: "100%"
                                    }}
                                >
                                    <p>
                                        <span>*</span>
                                        <br />
                                        <span />
                                        <br />
                                        <span />
                                        <br />
                                    </p>
                                </div>
                            </td>
                            <td
                                width="40%"
                                height={35}
                                align="center"
                                className="TeamCombo"
                                style={{
                                    height: 35,
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                    padding: 5,
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    className="ScoreCard"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "2px dotted #333",
                                        justifyContent: "center",
                                        height: "100%"
                                    }}
                                >
                                    <p style={{ fontSize: '14px' }}>
                                        <span>0-0 (0) (0-0)</span>
                                        <br />
                                        <span> (0-0)</span>
                                    </p>
                                </div>
                            </td>
                            <td
                                width="25%"
                                height={35}
                                align="center"
                                className="TeamCombo"
                                style={{
                                    height: 35,
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                    padding: 5,
                                    boxSizing: "border-box"
                                }}
                            >
                                <div
                                    className="ScoreCard"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "2px dotted #333",
                                        justifyContent: "center",
                                        height: "100%"
                                    }}
                                >
                                    <p>
                                        <span />
                                        <br />
                                    </p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr> */}
    </>;


    return (
        <>
            <tr>
                <td
                    colSpan={3}
                    height={35}
                    align="center"
                    className="TeamCombo"
                >
                    <p
                        className="price-btn"
                        style={{
                            color: "#00F",
                            fontFamily: "Verdana, Geneva, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold"
                        }}>
                        <span
                            style={{ textDecoration: "blink !important" }}>
                            {scoreData?.ScoreStatus}
                            {/* {scoreData?.NRMsg} */}
                        </span>
                        &nbsp;{" "}
                    </p>
                </td>
            </tr>
            <tr>
                <td align="left" valign="top" style={{ padding: '0px' }}>
                    <table width="100%" border={0} cellSpacing={0} cellPadding={0}>
                        <tbody>

                            <tr>
                                <td
                                    width="35%%"
                                    height={35}
                                    align="center"
                                    className="TeamCombo"
                                    style={{
                                        height: 35,
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                        padding: 5,
                                        boxSizing: "border-box"
                                    }}
                                >
                                    <div
                                        className="ScoreCard"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            // border: "2px dotted #333",
                                            justifyContent: "center",
                                            height: "100%"
                                        }}
                                    >
                                        <p>
                                            <span>
                                                {scoreData?.Player1} ({scoreData?.Player1Run})
                                            </span>
                                            <br />
                                            <span>
                                                {scoreData?.Player2} ({scoreData?.Player2Run})
                                            </span>
                                            <br />
                                            <span>
                                                {scoreData?.Bowler}
                                            </span>
                                            <br />
                                        </p>
                                    </div>
                                </td>
                                <td
                                    width="35%"
                                    height={35}
                                    align="center"
                                    className="TeamCombo"
                                    style={{
                                        height: 35,
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                        padding: 5,
                                        boxSizing: "border-box"
                                    }}
                                >
                                    <div
                                        className="ScoreCard"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            // border: "2px dotted #333",
                                            justifyContent: "center",
                                            height: "100%"
                                        }}
                                    >
                                        <p style={{ fontSize: '14px' }}>
                                            <span>{scoreData?.Team1Score}</span>
                                            <br />
                                            <span>{scoreData?.Team2Score}</span>
                                            <div className="d-flex gap-1 justify-content-center" style={{ gap: '2px' }}>
                                                <div>{scoreData?.CurrentOverBalls1}</div>
                                                <div>{scoreData?.CurrentOverBalls2}</div>
                                                <div>{scoreData?.CurrentOverBalls3}</div>
                                                <div>{scoreData?.CurrentOverBalls4}</div>
                                                <div>{scoreData?.CurrentOverBalls5}</div>
                                                <div>{scoreData?.CurrentOverBalls6}</div>
                                            </div>
                                        </p>
                                    </div>
                                </td>
                                <td
                                    width="35%%"
                                    height={35}
                                    align="center"
                                    className="TeamCombo"
                                    style={{
                                        height: 35,
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                        padding: 5,
                                        boxSizing: "border-box"
                                    }}
                                >
                                    <div
                                        className="ScoreCard"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            // border: "2px dotted #333",
                                            justifyContent: "center",
                                            height: "100%"
                                        }}
                                    >
                                        <p>
                                            <span>
                                                {scoreData?.LiveCommentary}
                                                {/* {scoreData?.ScoreStatus} */}
                                            </span>
                                            <br />
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            {/**/}
                        </tbody>
                    </table>
                </td>
            </tr>
        </>

    );
};

export default LiveScoreCardPHP;